import React, { useState } from 'react'
import { Field } from 'redux-form'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'
import '../../../styles/scss/components/equote-react-dates-overrides.scss'
import moment from 'moment'

const DateSelectionDropDown = props => {
  const [isFocused, setFocus] = useState(!props.selectedDate)
  return (
    <div className="equote-package-additional-details-form--input-group datepicker-container">
      <p
        className="equote-package-additional-details-form--input-group--label"
        style={{ flexWrap: 'wrap' }}
      >
        Departure Dates - Second Choice (optional)
      </p>
      <Field
        name="Date"
        component={input => {
          return (
            <SingleDatePicker
              displayFormat="MMMM DD, YYYY"
              readOnly
              date={props.selectedDate} // momentPropTypes.momentObj or null
              onDateChange={date => {
                input.input.onChange(date)
              }} // PropTypes.func.isRequired
              focused={isFocused} // PropTypes.bool
              onFocusChange={focused => {
                setFocus(focused.focused)
              }} // PropTypes.func.isRequired
              id="request-more-details-date-option" // PropTypes.string.isRequired,
              renderDayContents={day => {
                if (day && day.isSame(props.sailDate, 'day')) {
                  return (
                    <div className="calendar-package-sail-date">
                      {day.format('DD')}
                    </div>
                  )
                } else if (day) {
                  return <span>{day.format('DD')}</span>
                }
              }}
              isDayBlocked={day => {
                const formattedDay = day.format('YYYY-MM-DD'),
                  isAvailable =
                    props.availableDates &&
                    props.availableDates.find(day => day.date === formattedDay)
                return !Boolean(isAvailable)
              }}
              initialVisibleMonth={() => moment(props.sailDate, 'YYYY-MM-DD')}
              numberOfMonths={window.innerWidth > 768 ? 2 : 1}
            />
          )
        }}
      />
    </div>
  )
}

export default DateSelectionDropDown
